import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { FAQS } from "@/data/content";

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="paper-grid relative overflow-hidden py-24 lg:py-36">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-10">
            <SectionHeading
                id="faq-heading"
                align="center"
                overline="FAQ"
                title={<>Questions, <span className="text-flame-dark">answered straight.</span></>}
            />
            <Reveal delay={0.15}>
                <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem key={i} value={`faq-${i}`}
                            className="rounded-2xl border border-omsivo-navy/10 bg-white px-6 shadow-sm transition-colors data-[state=open]:border-flame/50">
                            <AccordionTrigger data-testid={`faq-trigger-${i}`}
                                className="py-5 text-left font-display text-[15px] font-bold tracking-wide text-omsivo-navy hover:no-underline">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
